import { FC, memo } from 'react'

import { Text } from '@cash-me/react-components'
import NextImage from 'next/image'

import { Breadcrumb } from 'components/breadcrumb'
import { Col, Grid } from 'components/grid'

import { benefits } from './data'
import * as S from './styles'

const breadcrumbItems = [{ label: 'Programa de Integridade' }]

const Benefits: FC = memo(() => (
  <S.Section>
    <Grid col={{ phone: 1, tablet: 1 }}>
      <Col col={{ desktop: 10 }} start={{ desktop: 2 }}>
        <Breadcrumb items={breadcrumbItems} linkColor="cyan-text-contrast" textColor="neutral-text-weak" />

        <S.TitleWrapper>
          <Text as="h2" size="heading2" weight="medium">
            <Text as="span" size="heading2" weight="medium" color="var(--colors-pink-text-contrast)">
              Benefícios
            </Text>{' '}
            do Programa
          </Text>
        </S.TitleWrapper>

        <S.Lead>
          <Text size="heading4" color="var(--colors-neutral-text-default)">
            A CashMe acredita que construir uma sociedade mais íntegra é dever de todos. Com o Programa de Integridade,
            buscamos levar aos nossos públicos as práticas e as atitudes esperadas por nós.
          </Text>
        </S.Lead>

        <S.Cards>
          {benefits.map(({ id, icon, text }, index) => (
            <S.Card key={id} $order={index}>
              <S.IconWrapper aria-hidden>
                <NextImage src={icon} alt="" width={24} height={24} />
              </S.IconWrapper>

              <Text size="bodySmall" color="var(--colors-neutral-text-contrast-default)">
                {text}
              </Text>
            </S.Card>
          ))}
        </S.Cards>
      </Col>
    </Grid>
  </S.Section>
))

Benefits.displayName = 'Benefits'

export default Benefits
